import { getAssetAccess } from '../../../../utils/player/asset';
import { getSubscriptionLabel } from '../../../../utils/subscription';
import { useTranslation } from '../../../../utils/useTranslation';
import { useAccessDefinitions } from '../../hooks/AccessDefinitionsProvider';
import { useCurrentAsset } from '../../hooks/CurrentAssetProvider';
import { useProvider } from '../../hooks/useProvider';
import ns from '../../translations';
import { Typography } from '../Typography/Typography';

export const SportUpcomingEventsLabel = () => {
  const { t } = useTranslation(ns);
  const { asset } = useCurrentAsset();
  const accessLevel = getAssetAccess(asset);
  const { accessDefinitions } = useAccessDefinitions();

  const label = t('See soon with', {
    subscription: getSubscriptionLabel(
      accessDefinitions,
      accessLevel as 'sport' | 'plus'
    ),
  });

  return (
    <Typography
      className="vgp-sport-upcoming-events-label"
      color="subtitle-text"
      variant="body"
      size="medium"
      bold
    >
      {label}
    </Typography>
  );
};
